import { Vector3 } from "three";
const TOL = 1e-5;
const closestPoint = new Vector3();
const midPoint = new Vector3();
function isLineOnEdges(line, edges) {
  if (!edges)
    return false;
  line.getCenter(midPoint);
  for (const edge of edges) {
    edge.closestPointToPoint(midPoint, true, closestPoint);
    const dist = closestPoint.distanceToSquared(midPoint);
    if (dist < TOL) {
      return true;
    }
  }
  return false;
}
export {
  isLineOnEdges
};
//# sourceMappingURL=index241.js.map
